import { useState } from "react";
import usePolling from "./usePolling";

export const useCachedWorkflowStats = () => {
  const [workflows, setWorkflows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  usePolling(async (isActive) => {
    try {
      const response = await fetch("/service/workflow-stats");
      if (!response.ok) throw new Error("Workflow usage is unavailable");

      const data = await response.json();

      if (!isActive()) return;
      setWorkflows(data.workflows);
      setError(null);
    } catch (err) {
      if (!isActive()) return;
      setError(err.message);
      setWorkflows([]);
    } finally {
      if (isActive()) setLoading(false);
    }
  }, 60 * 1000);

  return { workflows, loading, error };
};
